export default __webpack_public_path__ + "static/media/land.99b6e745.png";